import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, AfterViewInit, AfterContentInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { NodeOptionsObject } from "@app/workflow-common/diagram-view2/models/node.model";
import { DagSourceModel, InitialBlock } from "@app/workflow-common/services/DagSourceModel";
import { DiagramService } from "@app/workflow-common/diagram-view2/services/diagram.service";
import { combineLatest, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
var DiagramView2Component = /** @class */ (function () {
    function DiagramView2Component(_diagramService, changeDetection, workflowHttpService) {
        this._diagramService = _diagramService;
        this.changeDetection = changeDetection;
        this.workflowHttpService = workflowHttpService;
        this.direction = 'vertical';
        this.hasParent = false;
        this.dagSourceData = undefined;
        this.nodeOptions = new NodeOptionsObject();
        this.zoomoutLimit = 0.5;
        this.zoominLimit = 7;
        this.zoom = true;
        this.nodes = [];
        this.hasUpdatedNode = new EventEmitter();
        this.cursorVal = 'default';
        this.panning = false;
        this.startX = 0;
        this.startY = 0;
        this.transformVal = '';
        this.isNew = false;
        this.subscriptions = [];
        this.transitionOn = false;
        this._unsubscribeAll = new Subject();
        this.enablePan = false;
    }
    DiagramView2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.dagSourceModel = new DagSourceModel(this.dagSourceData);
        this.dagSourceModel.setTemplateId(this.settingsTypeId);
        if (this.nodeOptions.enablePan) {
            this.enablePan = this.nodeOptions.enablePan;
        }
        if (this.nodeOptions.viewMode == 'audit') {
            this.transitionOn = true;
        }
        this.nodes = this.dagSourceModel.getNodesFromModel();
        var _combine = combineLatest(this._diagramService.diagram$, this._diagramService.nodeUpdated$, this._diagramService.addNode$)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () { return _this.changeDetection.markForCheck(); });
        this.subscriptions.push(this._diagramService.diagram$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () {
        }));
        this.subscriptions.push(this._diagramService.nodeUpdated$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (isUpdated) {
            _this.hasUpdatedNode.emit(_this.dagSourceModel);
            if (isUpdated) {
                _this.isNew = false;
            }
        }));
        this.subscriptions.push(this._diagramService.autoSave$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (isAutoSaved) {
            var autoSave = _this.nodeOptions.autoSave;
            if (isAutoSaved && autoSave) {
                _this.updateDagSource();
            }
        }));
        // deleting exists node
        this.subscriptions.push(this._diagramService.deleteNode$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (_a) {
            var parentId = _a.parentId, index = _a.index;
            var findItem = function (nodes) {
                nodes.forEach(function (_node) {
                    if (_node.id == parentId) {
                        var parentNode = _node;
                        if (parentNode.children.length > 0) {
                            var count = 1;
                            if (parentNode.children.length === 2) {
                                index = index - 1;
                                count = 2;
                            }
                            parentNode.children.splice(index, count);
                        }
                        return;
                    }
                    findItem(_node.children);
                });
            };
            findItem(_this.nodes);
        }));
        // adding new node
        this.subscriptions.push(this._diagramService.addNode$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (_a) {
            var parentId = _a.parentId, node = _a.node;
            var findItem = function (nodes, pid) {
                nodes.forEach(function (_node) {
                    if (_node.id == pid) {
                        if (Array.isArray(node)) {
                            var newdata = node.map(function (item) {
                                if (!item.hasOwnProperty('children'))
                                    item.children = [];
                                return item;
                            });
                            _node.children.push(tslib_1.__assign({}, newdata[0]), tslib_1.__assign({}, newdata[1]));
                        }
                        else {
                            if (!node.hasOwnProperty('children'))
                                node.children = [];
                            //insert between
                            if (_node.children.length > 0 && _node['name'] != 'conditionalBlock') {
                                var downStreamNodes = _node.children;
                                node.children = downStreamNodes;
                                _node.children = [node];
                            }
                            else {
                                _node.children.push(node);
                            }
                        }
                        return;
                    }
                    findItem(_node.children, pid);
                });
            };
            findItem(_this.nodes, parentId);
        }));
        this.subscriptions.push(this._diagramService.adjustPositionY$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (nodeEl) {
            var top = nodeEl.getClientRects()[0].top;
            var newY = -(top - 80);
            if (_this.transformVal === '') {
                if (_this.transformVal.indexOf('3d') === -1) {
                    _this.transformVal = 'matrix(1,0,0,1,0,' + newY + ')';
                }
            }
        }));
        this.subscriptions.push(_combine);
        var metaData = this.nodeOptions.metaData;
        // this.dagSourceModel = new DagSourceModel(this.dagSourceData);
        this.dagSourceModel.setFieldMetadata(metaData.fields);
        if (this.nodes.length == 0) {
            this.nodes.push(new InitialBlock('cs_initializer', '0', 'initializer', 'AND', [], this.nodeOptions.objectName));
            this.isNew = true;
        }
        else {
            this.isNew = false;
        }
    };
    DiagramView2Component.prototype.zoomIn = function () {
        var newScale = 1 + 0.1;
        this._setChartScale(newScale);
    };
    DiagramView2Component.prototype.zoomOut = function () {
        var newScale = 1 + (-0.1);
        this._setChartScale(newScale);
    };
    DiagramView2Component.prototype.zoomReset = function () {
        this._setChartScale(1);
    };
    DiagramView2Component.prototype.updateDagSource = function () {
        var _a = this.nodeOptions, workflowType = _a.workflowType, workflowId = _a.workflowId;
        if (!workflowId) {
            console.error('Workflow ID not null...');
            return;
        }
        var automationUpdate = {
            'dagSource': this.dagSourceModel.getModel(),
        };
        this.workflowHttpService.updateDagSource(workflowId, { automationUpdate: automationUpdate })
            .subscribe({
            next: function (resp) {
                if (!resp.hasOwnProperty('workflowData')) {
                    console.error('automation not updated');
                }
            }
        });
    };
    DiagramView2Component.prototype._setChartScale = function (newScale) {
        var matrix = [];
        var targetScale = 1;
        if (this.transformVal === '') {
            this.transformVal = 'matrix(' + newScale + ', 0, 0, ' + newScale + ', 0, 0)';
        }
        else if (newScale === 1) {
            matrix = this.transformVal.split(',');
            if (this.transformVal.indexOf('3d') === -1) {
                matrix[0] = 'matrix(' + targetScale;
                matrix[3] = targetScale;
                this.transformVal = matrix.join(',');
            }
        }
        else {
            matrix = this.transformVal.split(',');
            if (this.transformVal.indexOf('3d') === -1) {
                targetScale = Math.abs(parseFloat(matrix[3]) * newScale);
                if (targetScale > this.zoomoutLimit && targetScale < this.zoominLimit) {
                    matrix[0] = 'matrix(' + targetScale;
                    matrix[3] = targetScale;
                    this.transformVal = matrix.join(',');
                }
            }
            else {
                targetScale = Math.abs(parseFloat(matrix[5]) * newScale);
                if (targetScale > this.zoomoutLimit && targetScale < this.zoominLimit) {
                    matrix[0] = 'matrix3d(' + targetScale;
                    matrix[5] = targetScale;
                    this.transformVal = matrix.join(',');
                }
            }
        }
    };
    DiagramView2Component.prototype.startPan = function (e) {
        if (!this.enablePan) {
            e.preventDefault();
            return;
        }
        this.cursorVal = 'move';
        this.panning = true;
        var lastX = 0;
        var lastY = 0;
        if (this.transformVal !== '') {
            var matrix = this.transformVal.split(',');
            if (this.transformVal.indexOf('3d') === -1) {
                lastX = parseInt(matrix[4], 10);
                lastY = parseInt(matrix[5], 10);
            }
            else {
                lastX = parseInt(matrix[12], 10);
                lastY = parseInt(matrix[13], 10);
            }
        }
        if (!e.targetTouches) {
            this.startX = e.pageX - lastX;
            this.startY = e.pageY - lastY;
        }
        else if (e.targetTouches.length === 1) {
            this.startX = e.targetTouches[0].pageX - lastX;
            this.startY = e.targetTouches[0].pageY - lastY;
        }
        else if (e.targetTouches.length > 1) {
            return;
        }
    };
    DiagramView2Component.prototype.panHandler = function (e) {
        if (!this.enablePan && this.cursorVal == 'move') {
            this.panning = false;
        }
        if (!this.panning) {
            e.preventDefault();
            return;
        }
        var newX = 0;
        var newY = 0;
        if (!e.targetTouches) {
            newX = e.pageX - this.startX;
            newY = e.pageY - this.startY;
        }
        else if (e.targetTouches.length === 1) {
            newX = e.targetTouches[0].pageX - this.startX;
            newY = e.targetTouches[0].pageY - this.startY;
        }
        else if (e.targetTouches.length > 1) {
            return;
        }
        if (this.transformVal === '') {
            if (this.transformVal.indexOf('3d') === -1) {
                this.transformVal = 'matrix(1,0,0,1,' + newX + ',' + newY + ')';
            }
            else {
                this.transformVal =
                    'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,' + newX + ', ' + newY + ',0,1)';
            }
        }
        else {
            var matrix = this.transformVal.split(',');
            if (this.transformVal.indexOf('3d') === -1) {
                matrix[4] = newX.toString();
                matrix[5] = newY + ')';
            }
            else {
                matrix[12] = newX.toString();
                matrix[13] = newY.toString();
            }
            this.transformVal = matrix.join(',');
        }
    };
    ///@HostListener('window:mousemove', ['$event'])
    DiagramView2Component.prototype.mouseMove = function (event) {
        this.panHandler(event);
    };
    //@HostListener('window:mouseup', ['$event'])
    DiagramView2Component.prototype.mouseUp = function (event) {
        this.panning = false;
        this.cursorVal = 'default';
    };
    //@HostListener('window:mousedown', ['$event'])
    DiagramView2Component.prototype.mouseDown = function (event) {
        var element = event.target;
        //if(element.tagName == 'APP-DIAGRAM-VIEW2' ||  element.classList.contains('wf-diagram')) {
        this.startPan(event);
        //}
        //event.preventDefault();
    };
    DiagramView2Component.prototype.ngOnDestroy = function () {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    };
    DiagramView2Component.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.transitionOn = false;
        }, 2500);
    };
    DiagramView2Component.prototype.ngAfterContentInit = function () {
    };
    return DiagramView2Component;
}());
export { DiagramView2Component };
